// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import VueGoodTable from 'my-account-table'

import App from './App'

import router from './router'
import { configureRouter } from './router/routerConfig'
import VeeValidate from 'vee-validate'
import VueTheMask from 'vue-the-mask'
import dictionary from './assets/validation-messages'

import Toasted from 'vue-toasted'
require('../node_modules/my-account-common-css/stylesheets/vue-toast-customization.scss')

const config = {
  locale: 'en',
  dictionary: dictionary,
  events: 'input'
}

Vue.use(VueTheMask)
Vue.use(VeeValidate, config)
Vue.use(ElementUI, {locale})
Vue.use(VueGoodTable)
Vue.use(Toasted)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {App}
})
configureRouter(router)



// WEBPACK FOOTER //
// ./src/main.js